import { DataSource, HorizontalSpacer, Label, Layout, Panel, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutAdditionalDetailsFTLUnauthenticated extends Layout {
    horizontalspacer1: HorizontalSpacer;
    labelAdditionalDetails: Label;
    labelReferenceNumbers: Label;
    panelAdditionalDetailsFTL: Panel;
    sourceCustomerOrderDetail: DataSource;
    tableReferenceNumbers: Table;
    textboxCommodity: Textbox;
    textboxReturnTemp: Textbox;
    textboxTractor: Textbox;
    textboxTrailer: Textbox;
}
